import { FC, memo, useState } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { Table } from 'ui/components/Table'
import { ClientUserListResponseItem } from '~bank-client-users/types'

import { useClientUsersListContext } from '../../context/ClientUsersListContext'
import { ClientUsersTableProps } from './ClientUsersTableProps'
import { columns } from './columns'
import { Filter, UserRelationshipsApplicationsDialog } from './components'

export const ClientUsersTable: FC<ClientUsersTableProps> = memo((props) => {
  const { setEditClientUser, setRemovingClientUser, sendInviteLink } = props
  const { data, isPending, state, navigate } = useClientUsersListContext()
  const { page, size } = state
  const [showUserRelationships, setShowUserRelationships] = useState<ClientUserListResponseItem | undefined>(undefined)

  return (
    <Layer rounded shadowed stretch>
      {!!showUserRelationships && (
        <UserRelationshipsApplicationsDialog
          user={showUserRelationships}
          onClose={() => setShowUserRelationships(undefined)}
        />
      )}
      <Filter />
      <Table<ClientUserListResponseItem>
        dataQa={TableDataQa.BP_CLIENT_USERS_LIST}
        dataSource={(data?.clientUsers || []).map((item) => ({ item }))}
        loading={isPending}
        columns={columns(setShowUserRelationships, setEditClientUser, setRemovingClientUser, sendInviteLink)}
        pagination={{
          page,
          size,
          total: data?.totalCount,
          onChange: (page: number, size: number) => {
            navigate({ page, size })
          }
        }}
      />
    </Layer>
  )
})
